import { ItineraryService } from './../itinerary.service';
import { User } from './../user.model';
import { UserService } from './../user.service';
import { ActivatedRoute } from "@angular/router";
import { DaysBetweenPipe } from "./../days-between.pipe";
import { Itinerary } from "./../itineray.model";
import { Component, OnInit } from "@angular/core";

import * as firebase from "firebase/app";
import "firebase/firestore";

@Component({
  selector: "app-itinerary-info",
  templateUrl: "./itinerary-info.component.html",
  styleUrls: ["./itinerary-info.component.css"]
})
export class ItineraryInfoComponent implements OnInit {
  constructor(private route: ActivatedRoute, public userService: UserService, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;
  users: User[];

  startEndDatesLocked: boolean;

  async ngOnInit() {
    this.itinerary = this.route.parent.snapshot.data.itinerary;
    if (this.itinerary.start && this.itinerary.end) {
      this.startEndDatesLocked = true;
    }
  }
  onStartEndChange() {
    if (!this.itinerary.start || !this.itinerary.end) { return; }

    const nDays = new DaysBetweenPipe().transform({
      start: this.itinerary.start.toDate(),
      end: this.itinerary.end.toDate()
    });

    if (nDays <= 0) {
      this.itinerary.days.splice(0, this.itinerary.days.length);
      return;
    }

    while (nDays > this.itinerary.days.length) {
      this.itinerary.days.push({ activities: [], title: "", description: "", date: null, pois: [], link: { longUrl: null, shortUrl: null } });
    }
    while (nDays < this.itinerary.days.length) {
      this.itinerary.days.splice(this.itinerary.days.length - 1, 1);
    }

    for (let i = 0; i < this.itinerary.days.length; i++) {
      const day = this.itinerary.days[i];
      day.date = firebase.firestore.Timestamp.fromDate(
        new Date(
          this.itinerary.start.toDate().getTime() + 1000 * 60 * 60 * 24 * i
        )
      );
      if (!day.activities) {
        day.activities = [];
      }
    }
  }

  unlockStartEndDates() {
    if (confirm("Attenzione! Se il numero di giorni dell'itinerario diminuisce, i giorni in eccesso saranno eliminati, insieme a tutte le loro informazioni.\nSei veramente sicuro di voler modificare le date?\nSe hai qualche dubbio contattaci.")) {
      this.startEndDatesLocked = false;
    }
  }
}
